import React from 'react';
import PropTypes from 'prop-types';
import Checkmark from '../../icons/checkmark.svg';

import styles from './index.module.scss';

const regEx = /[^a-z0-9]/gi;

const Checkbox = ({
  checked, onClick, label, id
}) => {
  const checkboxId = id || `checkbox-${label.toLowerCase().replace(regEx, '')}`;

  return (
    <div className={styles.checkboxContainer} onClick={onClick}>
      <div
        className={`${styles.box} ${checked ? styles.checked : ''}`}
        id={checkboxId}
      >
        {checked
        && <Checkmark />}
      </div>
      <label
        className={styles.checkboxLabel}
        id={`label-${label.toLowerCase().split(' ').join('_')}`}
        htmlFor={checkboxId}
      >
        {label}
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  onClick: PropTypes.func,
  id: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
};

export default Checkbox;
